module.exports = __webpack_public_path__ + "static/img/xcmx.5121900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/xcmx.png
// module id = 1/Vp
// module chunks = 0